// extracted by mini-css-extract-plugin
module.exports = {"clientReferralWrapper":"ClientReferral_clientReferralWrapper__3Q2-R","title":"ClientReferral_title__56gyW","itemText":"ClientReferral_itemText__10t9E"};